import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc403cac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "template_dropdown"
}
const _hoisted_2 = {
  key: 0,
  class: "template_search_wrapper"
}
const _hoisted_3 = { class: "template_search_field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "template_search_icon",
  src: "/assets/img/search.svg"
}, null, -1))
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "template_list" }
const _hoisted_7 = {
  key: 0,
  class: "template_empty"
}
const _hoisted_8 = {
  key: 1,
  class: "template_empty"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "template_empty_icon",
  src: "/assets/img/search.svg"
}, null, -1))
const _hoisted_10 = {
  key: 2,
  class: "template_empty"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "template_empty_icon",
  src: "/assets/img/search.svg"
}, null, -1))
const _hoisted_12 = ["onClick", "onMouseenter"]
const _hoisted_13 = { class: "template_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Transition, { name: "template-slide" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.loading && !_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _withDirectives(_createElementVNode("input", {
                      class: "template_search_input",
                      placeholder: _ctx.$t('chat.templates_search'),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                      ref: "searchInput",
                      onKeydown: [
                        _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('close')), ["esc"])),
                        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.moveHighlight(1)), ["prevent"]), ["down"])),
                        _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.moveHighlight(-1)), ["prevent"]), ["up"])),
                        _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.selectHighlighted && _ctx.selectHighlighted(...args)), ["prevent"]), ["enter"]))
                      ]
                    }, null, 40, _hoisted_5), [
                      [_vModelText, _ctx.searchQuery]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('chat.templates_loading')), 1)
                  ]))
                : (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('chat.templates_error')), 1)
                    ]))
                  : (_ctx.filtered.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('chat.templates_empty')), 1)
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.filtered, (template, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: template.id,
                          class: _normalizeClass(["template_item", { template_item_highlighted: index === _ctx.highlightedIndex }]),
                          onClick: ($event: any) => (_ctx.$emit('select', template)),
                          onMouseenter: ($event: any) => (_ctx.highlightedIndex = index)
                        }, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(template.text), 1)
                        ], 42, _hoisted_12))
                      }), 128))
            ])
          ])), [
            [_directive_click_outside, _ctx.onClickOutside]
          ])
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}